import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo, useRef } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_devices_filtered_by_state } from 'console/redux/selectors';
import { TreeContext } from 'console/sortableDeviceTree/context/type';
import { useSelectDeviceTree } from 'console/account/popup-for-pro';
import { findNodeInTree, findSelectedDeviceInTree, } from 'console/sortableDeviceTree/utils/find-node-in-tree';
import { convertDeviceTreeForTreeData, deviceTreeWithLostDevices, } from 'console/sortableDeviceTree/utils/device-tree-utils';
import { replaceDevicesForTree } from 'console/sortableDeviceTree/utils/replace-devices-for-tree';
import { selectNullableSelectedDeviceId } from 'entities/device/lib';
import { useForceUpdate } from 'framer-motion';
function useIsFirstRender() {
    const isFirst = useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
export const TreeContextProvider = memo(function TreeContextProvider(props) {
    const { search, are_filters_selected, children } = props;
    const devices = useAppSelector(select_devices_filtered_by_state) ?? [];
    const device_tree = useSelectDeviceTree();
    const selected_device_id = useAppSelector(selectNullableSelectedDeviceId);
    const user_id = useAppSelector((state) => state.account.id);
    const is_first_render = useIsFirstRender();
    const mathRandom = useAppSelector((state) => state.scrollRandom?.mathRandom);
    const filteredTree = useMemo(() => findNodeInTree(replaceDevicesForTree(convertDeviceTreeForTreeData(deviceTreeWithLostDevices(device_tree, devices)), devices), search, are_filters_selected), [device_tree, devices, search, are_filters_selected]);
    const [forceUpdate] = useForceUpdate();
    const canDrag = useMemo(() => search === '' && !are_filters_selected, [search, are_filters_selected]);
    const selected_device_index = useMemo(() => findSelectedDeviceInTree(filteredTree, selected_device_id, is_first_render), [filteredTree, selected_device_id, is_first_render]);
    const context = useMemo(() => ({
        selected_device_id,
        mathRandom,
        user_id,
        filteredTree,
        canDrag,
        selected_device_index,
        are_filters_selected,
        forceUpdate,
    }), [
        selected_device_id,
        user_id,
        mathRandom,
        filteredTree,
        canDrag,
        selected_device_index,
        are_filters_selected,
        forceUpdate,
    ]);
    return _jsx(TreeContext.Provider, { value: context, children: children });
});
